import AppFlowActions from '../../constants';

export function loginRequest(data) {
  return ({ type: AppFlowActions.LOGIN_REQUEST, data });
}

export function loginComplete(data) {
  return ({ type: AppFlowActions.LOGIN_COMPLETE, data });
}

export function logoutRequest(data) {
  return ({ type: AppFlowActions.LOGOUT_REQUEST, data });
}
